module.exports = __webpack_public_path__ + "img/kommune-1504.baa11df4.svg";